






















import Vue from "vue"
import color from "~/config/color"

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    keyColor() {
      return color.keyColor
    },
  },
  methods: {
    handleChange() {
      this.$emit("change", !this.value)
    },
  },
})
